import _asyncToGenerator from "/home/runner/work/aws-otel.github.io/aws-otel.github.io/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/runner/work/aws-otel.github.io/aws-otel.github.io/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/aws-otel.github.io/aws-otel.github.io/node_modules/@babel/runtime/helpers/esm/createClass.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import _regeneratorRuntime from "/home/runner/work/aws-otel.github.io/aws-otel.github.io/node_modules/@babel/runtime/regenerator/index.js";
import { HeaderMarshaller } from "@aws-sdk/eventstream-codec";
import { toHex } from "@aws-sdk/util-hex-encoding";
import { normalizeProvider } from "@aws-sdk/util-middleware";
import { fromUtf8, toUint8Array, toUtf8 } from "@aws-sdk/util-utf8";
import { ALGORITHM_IDENTIFIER, ALGORITHM_QUERY_PARAM, AMZ_DATE_HEADER, AMZ_DATE_QUERY_PARAM, AUTH_HEADER, CREDENTIAL_QUERY_PARAM, EVENT_ALGORITHM_IDENTIFIER, EXPIRES_QUERY_PARAM, MAX_PRESIGNED_TTL, SHA256_HEADER, SIGNATURE_QUERY_PARAM, SIGNED_HEADERS_QUERY_PARAM, TOKEN_HEADER, TOKEN_QUERY_PARAM } from "./constants";
import { createScope, getSigningKey as _getSigningKey } from "./credentialDerivation";
import { getCanonicalHeaders } from "./getCanonicalHeaders";
import { getCanonicalQuery } from "./getCanonicalQuery";
import { getPayloadHash } from "./getPayloadHash";
import { hasHeader } from "./headerUtil";
import { moveHeadersToQuery } from "./moveHeadersToQuery";
import { prepareRequest } from "./prepareRequest";
import { iso8601 } from "./utilDate";
export var SignatureV4 = /*#__PURE__*/function () {
  function SignatureV4(_ref) {
    var applyChecksum = _ref.applyChecksum,
      credentials = _ref.credentials,
      region = _ref.region,
      service = _ref.service,
      sha256 = _ref.sha256,
      _ref$uriEscapePath = _ref.uriEscapePath,
      uriEscapePath = _ref$uriEscapePath === void 0 ? true : _ref$uriEscapePath;
    _classCallCheck(this, SignatureV4);
    this.headerMarshaller = new HeaderMarshaller(toUtf8, fromUtf8);
    this.service = service;
    this.sha256 = sha256;
    this.uriEscapePath = uriEscapePath;
    this.applyChecksum = typeof applyChecksum === "boolean" ? applyChecksum : true;
    this.regionProvider = normalizeProvider(region);
    this.credentialProvider = normalizeProvider(credentials);
  }
  _createClass(SignatureV4, [{
    key: "presign",
    value: function () {
      var _presign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(originalRequest) {
        var options,
          _options$signingDate,
          signingDate,
          _options$expiresIn,
          expiresIn,
          unsignableHeaders,
          unhoistableHeaders,
          signableHeaders,
          signingRegion,
          signingService,
          credentials,
          region,
          _formatDate,
          longDate,
          shortDate,
          scope,
          request,
          canonicalHeaders,
          _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                _options$signingDate = options.signingDate, signingDate = _options$signingDate === void 0 ? new Date() : _options$signingDate, _options$expiresIn = options.expiresIn, expiresIn = _options$expiresIn === void 0 ? 3600 : _options$expiresIn, unsignableHeaders = options.unsignableHeaders, unhoistableHeaders = options.unhoistableHeaders, signableHeaders = options.signableHeaders, signingRegion = options.signingRegion, signingService = options.signingService;
                _context.next = 4;
                return this.credentialProvider();
              case 4:
                credentials = _context.sent;
                this.validateResolvedCredentials(credentials);
                if (!(signingRegion !== null && signingRegion !== void 0)) {
                  _context.next = 10;
                  break;
                }
                _context.t0 = signingRegion;
                _context.next = 13;
                break;
              case 10:
                _context.next = 12;
                return this.regionProvider();
              case 12:
                _context.t0 = _context.sent;
              case 13:
                region = _context.t0;
                _formatDate = formatDate(signingDate), longDate = _formatDate.longDate, shortDate = _formatDate.shortDate;
                if (!(expiresIn > MAX_PRESIGNED_TTL)) {
                  _context.next = 17;
                  break;
                }
                return _context.abrupt("return", Promise.reject("Signature version 4 presigned URLs" + " must have an expiration date less than one week in" + " the future"));
              case 17:
                scope = createScope(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                request = moveHeadersToQuery(prepareRequest(originalRequest), {
                  unhoistableHeaders: unhoistableHeaders
                });
                if (credentials.sessionToken) {
                  request.query[TOKEN_QUERY_PARAM] = credentials.sessionToken;
                }
                request.query[ALGORITHM_QUERY_PARAM] = ALGORITHM_IDENTIFIER;
                request.query[CREDENTIAL_QUERY_PARAM] = "".concat(credentials.accessKeyId, "/").concat(scope);
                request.query[AMZ_DATE_QUERY_PARAM] = longDate;
                request.query[EXPIRES_QUERY_PARAM] = expiresIn.toString(10);
                canonicalHeaders = getCanonicalHeaders(request, unsignableHeaders, signableHeaders);
                request.query[SIGNED_HEADERS_QUERY_PARAM] = getCanonicalHeaderList(canonicalHeaders);
                _context.t1 = this;
                _context.t2 = longDate;
                _context.t3 = scope;
                _context.t4 = this.getSigningKey(credentials, region, shortDate, signingService);
                _context.t5 = this;
                _context.t6 = request;
                _context.t7 = canonicalHeaders;
                _context.next = 35;
                return getPayloadHash(originalRequest, this.sha256);
              case 35:
                _context.t8 = _context.sent;
                _context.t9 = _context.t5.createCanonicalRequest.call(_context.t5, _context.t6, _context.t7, _context.t8);
                _context.next = 39;
                return _context.t1.getSignature.call(_context.t1, _context.t2, _context.t3, _context.t4, _context.t9);
              case 39:
                request.query[SIGNATURE_QUERY_PARAM] = _context.sent;
                return _context.abrupt("return", request);
              case 41:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function presign(_x) {
        return _presign.apply(this, arguments);
      }
      return presign;
    }()
  }, {
    key: "sign",
    value: function () {
      var _sign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(toSign, options) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(typeof toSign === "string")) {
                  _context2.next = 4;
                  break;
                }
                return _context2.abrupt("return", this.signString(toSign, options));
              case 4:
                if (!(toSign.headers && toSign.payload)) {
                  _context2.next = 8;
                  break;
                }
                return _context2.abrupt("return", this.signEvent(toSign, options));
              case 8:
                if (!toSign.message) {
                  _context2.next = 12;
                  break;
                }
                return _context2.abrupt("return", this.signMessage(toSign, options));
              case 12:
                return _context2.abrupt("return", this.signRequest(toSign, options));
              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function sign(_x2, _x3) {
        return _sign.apply(this, arguments);
      }
      return sign;
    }()
  }, {
    key: "signEvent",
    value: function () {
      var _signEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref2, _ref3) {
        var headers, payload, _ref3$signingDate, signingDate, priorSignature, signingRegion, signingService, region, _formatDate2, shortDate, longDate, scope, hashedPayload, hash, hashedHeaders, stringToSign;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                headers = _ref2.headers, payload = _ref2.payload;
                _ref3$signingDate = _ref3.signingDate, signingDate = _ref3$signingDate === void 0 ? new Date() : _ref3$signingDate, priorSignature = _ref3.priorSignature, signingRegion = _ref3.signingRegion, signingService = _ref3.signingService;
                if (!(signingRegion !== null && signingRegion !== void 0)) {
                  _context3.next = 6;
                  break;
                }
                _context3.t0 = signingRegion;
                _context3.next = 9;
                break;
              case 6:
                _context3.next = 8;
                return this.regionProvider();
              case 8:
                _context3.t0 = _context3.sent;
              case 9:
                region = _context3.t0;
                _formatDate2 = formatDate(signingDate), shortDate = _formatDate2.shortDate, longDate = _formatDate2.longDate;
                scope = createScope(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                _context3.next = 14;
                return getPayloadHash({
                  headers: {},
                  body: payload
                }, this.sha256);
              case 14:
                hashedPayload = _context3.sent;
                hash = new this.sha256();
                hash.update(headers);
                _context3.t1 = toHex;
                _context3.next = 20;
                return hash.digest();
              case 20:
                _context3.t2 = _context3.sent;
                hashedHeaders = (0, _context3.t1)(_context3.t2);
                stringToSign = [EVENT_ALGORITHM_IDENTIFIER, longDate, scope, priorSignature, hashedHeaders, hashedPayload].join("\n");
                return _context3.abrupt("return", this.signString(stringToSign, {
                  signingDate: signingDate,
                  signingRegion: region,
                  signingService: signingService
                }));
              case 24:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function signEvent(_x4, _x5) {
        return _signEvent.apply(this, arguments);
      }
      return signEvent;
    }()
  }, {
    key: "signMessage",
    value: function () {
      var _signMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(signableMessage, _ref4) {
        var _ref4$signingDate, signingDate, signingRegion, signingService, promise;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _ref4$signingDate = _ref4.signingDate, signingDate = _ref4$signingDate === void 0 ? new Date() : _ref4$signingDate, signingRegion = _ref4.signingRegion, signingService = _ref4.signingService;
                promise = this.signEvent({
                  headers: this.headerMarshaller.format(signableMessage.message.headers),
                  payload: signableMessage.message.body
                }, {
                  signingDate: signingDate,
                  signingRegion: signingRegion,
                  signingService: signingService,
                  priorSignature: signableMessage.priorSignature
                });
                return _context4.abrupt("return", promise.then(function (signature) {
                  return {
                    message: signableMessage.message,
                    signature: signature
                  };
                }));
              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
      function signMessage(_x6, _x7) {
        return _signMessage.apply(this, arguments);
      }
      return signMessage;
    }()
  }, {
    key: "signString",
    value: function () {
      var _signString = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(stringToSign) {
        var _ref5,
          _ref5$signingDate,
          signingDate,
          signingRegion,
          signingService,
          credentials,
          region,
          _formatDate3,
          shortDate,
          hash,
          _args5 = arguments;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _ref5 = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {}, _ref5$signingDate = _ref5.signingDate, signingDate = _ref5$signingDate === void 0 ? new Date() : _ref5$signingDate, signingRegion = _ref5.signingRegion, signingService = _ref5.signingService;
                _context5.next = 3;
                return this.credentialProvider();
              case 3:
                credentials = _context5.sent;
                this.validateResolvedCredentials(credentials);
                if (!(signingRegion !== null && signingRegion !== void 0)) {
                  _context5.next = 9;
                  break;
                }
                _context5.t0 = signingRegion;
                _context5.next = 12;
                break;
              case 9:
                _context5.next = 11;
                return this.regionProvider();
              case 11:
                _context5.t0 = _context5.sent;
              case 12:
                region = _context5.t0;
                _formatDate3 = formatDate(signingDate), shortDate = _formatDate3.shortDate;
                _context5.t1 = this.sha256;
                _context5.next = 17;
                return this.getSigningKey(credentials, region, shortDate, signingService);
              case 17:
                _context5.t2 = _context5.sent;
                hash = new _context5.t1(_context5.t2);
                hash.update(toUint8Array(stringToSign));
                _context5.t3 = toHex;
                _context5.next = 23;
                return hash.digest();
              case 23:
                _context5.t4 = _context5.sent;
                return _context5.abrupt("return", (0, _context5.t3)(_context5.t4));
              case 25:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
      function signString(_x8) {
        return _signString.apply(this, arguments);
      }
      return signString;
    }()
  }, {
    key: "signRequest",
    value: function () {
      var _signRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(requestToSign) {
        var _ref6,
          _ref6$signingDate,
          signingDate,
          signableHeaders,
          unsignableHeaders,
          signingRegion,
          signingService,
          credentials,
          region,
          request,
          _formatDate4,
          longDate,
          shortDate,
          scope,
          payloadHash,
          canonicalHeaders,
          signature,
          _args6 = arguments;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _ref6 = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : {}, _ref6$signingDate = _ref6.signingDate, signingDate = _ref6$signingDate === void 0 ? new Date() : _ref6$signingDate, signableHeaders = _ref6.signableHeaders, unsignableHeaders = _ref6.unsignableHeaders, signingRegion = _ref6.signingRegion, signingService = _ref6.signingService;
                _context6.next = 3;
                return this.credentialProvider();
              case 3:
                credentials = _context6.sent;
                this.validateResolvedCredentials(credentials);
                if (!(signingRegion !== null && signingRegion !== void 0)) {
                  _context6.next = 9;
                  break;
                }
                _context6.t0 = signingRegion;
                _context6.next = 12;
                break;
              case 9:
                _context6.next = 11;
                return this.regionProvider();
              case 11:
                _context6.t0 = _context6.sent;
              case 12:
                region = _context6.t0;
                request = prepareRequest(requestToSign);
                _formatDate4 = formatDate(signingDate), longDate = _formatDate4.longDate, shortDate = _formatDate4.shortDate;
                scope = createScope(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                request.headers[AMZ_DATE_HEADER] = longDate;
                if (credentials.sessionToken) {
                  request.headers[TOKEN_HEADER] = credentials.sessionToken;
                }
                _context6.next = 20;
                return getPayloadHash(request, this.sha256);
              case 20:
                payloadHash = _context6.sent;
                if (!hasHeader(SHA256_HEADER, request.headers) && this.applyChecksum) {
                  request.headers[SHA256_HEADER] = payloadHash;
                }
                canonicalHeaders = getCanonicalHeaders(request, unsignableHeaders, signableHeaders);
                _context6.next = 25;
                return this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, payloadHash));
              case 25:
                signature = _context6.sent;
                request.headers[AUTH_HEADER] = "".concat(ALGORITHM_IDENTIFIER, " ") + "Credential=".concat(credentials.accessKeyId, "/").concat(scope, ", ") + "SignedHeaders=".concat(getCanonicalHeaderList(canonicalHeaders), ", ") + "Signature=".concat(signature);
                return _context6.abrupt("return", request);
              case 28:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
      function signRequest(_x9) {
        return _signRequest.apply(this, arguments);
      }
      return signRequest;
    }()
  }, {
    key: "createCanonicalRequest",
    value: function createCanonicalRequest(request, canonicalHeaders, payloadHash) {
      var sortedHeaders = Object.keys(canonicalHeaders).sort();
      return "".concat(request.method, "\n").concat(this.getCanonicalPath(request), "\n").concat(getCanonicalQuery(request), "\n").concat(sortedHeaders.map(function (name) {
        return "".concat(name, ":").concat(canonicalHeaders[name]);
      }).join("\n"), "\n\n").concat(sortedHeaders.join(";"), "\n").concat(payloadHash);
    }
  }, {
    key: "createStringToSign",
    value: function () {
      var _createStringToSign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(longDate, credentialScope, canonicalRequest) {
        var hash, hashedRequest;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                hash = new this.sha256();
                hash.update(toUint8Array(canonicalRequest));
                _context7.next = 4;
                return hash.digest();
              case 4:
                hashedRequest = _context7.sent;
                return _context7.abrupt("return", "".concat(ALGORITHM_IDENTIFIER, "\n").concat(longDate, "\n").concat(credentialScope, "\n").concat(toHex(hashedRequest)));
              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
      function createStringToSign(_x10, _x11, _x12) {
        return _createStringToSign.apply(this, arguments);
      }
      return createStringToSign;
    }()
  }, {
    key: "getCanonicalPath",
    value: function getCanonicalPath(_ref7) {
      var path = _ref7.path;
      if (this.uriEscapePath) {
        var normalizedPathSegments = [];
        var _iterator = _createForOfIteratorHelper(path.split("/")),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var pathSegment = _step.value;
            if ((pathSegment === null || pathSegment === void 0 ? void 0 : pathSegment.length) === 0) continue;
            if (pathSegment === ".") continue;
            if (pathSegment === "..") {
              normalizedPathSegments.pop();
            } else {
              normalizedPathSegments.push(pathSegment);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        var normalizedPath = "".concat(path !== null && path !== void 0 && path.startsWith("/") ? "/" : "").concat(normalizedPathSegments.join("/")).concat(normalizedPathSegments.length > 0 && path !== null && path !== void 0 && path.endsWith("/") ? "/" : "");
        var doubleEncoded = encodeURIComponent(normalizedPath);
        return doubleEncoded.replace(/%2F/g, "/");
      }
      return path;
    }
  }, {
    key: "getSignature",
    value: function () {
      var _getSignature = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(longDate, credentialScope, keyPromise, canonicalRequest) {
        var stringToSign, hash;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.createStringToSign(longDate, credentialScope, canonicalRequest);
              case 2:
                stringToSign = _context8.sent;
                _context8.t0 = this.sha256;
                _context8.next = 6;
                return keyPromise;
              case 6:
                _context8.t1 = _context8.sent;
                hash = new _context8.t0(_context8.t1);
                hash.update(toUint8Array(stringToSign));
                _context8.t2 = toHex;
                _context8.next = 12;
                return hash.digest();
              case 12:
                _context8.t3 = _context8.sent;
                return _context8.abrupt("return", (0, _context8.t2)(_context8.t3));
              case 14:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
      function getSignature(_x13, _x14, _x15, _x16) {
        return _getSignature.apply(this, arguments);
      }
      return getSignature;
    }()
  }, {
    key: "getSigningKey",
    value: function getSigningKey(credentials, region, shortDate, service) {
      return _getSigningKey(this.sha256, credentials, shortDate, region, service || this.service);
    }
  }, {
    key: "validateResolvedCredentials",
    value: function validateResolvedCredentials(credentials) {
      if (typeof credentials !== "object" || typeof credentials.accessKeyId !== "string" || typeof credentials.secretAccessKey !== "string") {
        throw new Error("Resolved credential object is not valid");
      }
    }
  }]);
  return SignatureV4;
}();
var formatDate = function formatDate(now) {
  var longDate = iso8601(now).replace(/[\-:]/g, "");
  return {
    longDate: longDate,
    shortDate: longDate.slice(0, 8)
  };
};
var getCanonicalHeaderList = function getCanonicalHeaderList(headers) {
  return Object.keys(headers).sort().join(";");
};